(function () {
    "use strict";

    angular.module("ib-passenger-info-form-module").controller("PassengerInfoFormController", PassengerInfoFormController);

    PassengerInfoFormController.$inject = ["$scope", "FlightsPassengersUtils", "CheckinAppConstants", "$timeout"];
    function PassengerInfoFormController($scope, FlightsPassengersUtils, CheckinAppConstants, $timeout) {
        const vm = this;
        let previousCompanySelection;

        vm.ckeckApisUsTracing = {};
        vm.$onInit = activate;
        $scope.$on("nationalityChange", changeNationality);
        vm.clearCodeNumber = clearCodeNumber;
        vm.updatePassenger = updatePassenger;
        vm.updateDataUseForAll = updateDataUseForAll;
        vm.openModalMoreInformation = openModalMoreInformation;
        vm.checkUsTracingAPIS = checkUsTracingAPIS;
        vm.includesHomeAddress = false;
        vm.isUnique = false;
        vm.countErrorNationalitySurname = 0;

        ////////////////

        function activate() {
            vm.checkUsTracingAPIS();
            vm.includesHomeAddress = includesHomeAddress();
            vm.isUnique = isUnique();
        }

        function changeNationality(event) {
            updateDataUseForAll(vm.passengersData);
        }

        /**
         * Emits event to open modal window with text
         * @param {String} text Text to show in modal
         */
        function openModalMoreInformation(text) {
            $scope.$emit("openModal", text);
        }

        /**
         * Update the values of passenger for show/hide options in data contact tab and
         * emits events to calculate passengers boarding cards left.
         * @param {Object} passengerData Info of passenger selected boardingCard
         */
        function updateDataUseForAll(passengerData) {
            if (!passengerData.basicInfo.isInfant) {
                $scope.$emit("updateUseDataForAll", passengerData.id);
            }
            $scope.$emit("updateShowBoardingCard", passengerData.id);
        }

        /**
         * Emits an event to complete the next tab
         */
        function updatePassenger($event) {
            const confirmEmergencyData = "confirmEmergencyData_" + vm.passengersData.id;
            const usPrivacyEmergencyData = "usPrivacyEmergencyData_" + vm.passengersData.id;
            const passengerSurname = "surname_" + vm.index;
            const checksUsTracing =
                angular.isDefined(vm.ckeckApisUsTracing.show) &&
                vm.ckeckApisUsTracing.show &&
                angular.isDefined(vm.passengersData[confirmEmergencyData]) &&
                angular.isDefined(vm.passengersData[usPrivacyEmergencyData]);
            const existErrorNationalitySurname = vm.containerForm[passengerSurname]?.$error?.nationality;

            if (existErrorNationalitySurname) {
                vm.countErrorNationalitySurname++;
                $timeout(() => {
                    angular.element("html, body").animate({ scrollTop: angular.element("#APIS_SURNAME_" + vm.index).offset().top - 70 });
                });
            } else {
                const existConfirmEmergencyData = vm.passengersData[confirmEmergencyData];
                const existUsPrivacyEmergencyData = vm.passengersData[usPrivacyEmergencyData];
                const isAllTrueInfo = checksUsTracing && existConfirmEmergencyData && existUsPrivacyEmergencyData;
                const isAllFalseInfo = checksUsTracing && (!existConfirmEmergencyData || !existUsPrivacyEmergencyData);

                if (isAllTrueInfo) vm.passengersData.allTrueInfo = true;
                else if (isAllFalseInfo) vm.passengersData.allTrueInfo = false;

                if (vm.countErrorNationalitySurname > 0 && vm.containerForm?.$submitted) vm.containerForm.$submitted = false;

                $scope.$emit("completeNextFormEvent");
                if ($event) $event.preventDefault();
            }
        }

        /**
         * @function
         * @name clearCodeNumber
         * @desc Clean the previous company code number if a company is selected
         * @returns
         */
        function clearCodeNumber() {
            if (previousCompanySelection !== "IB") {
                previousCompanySelection = vm.passengersData.frequentFlyer.iataCompanyCode;
                if (vm.passengersData.frequentFlyer.iataCompanyCode === "IB") {
                    vm.passengersData.frequentFlyer.number = "";
                }
            } else {
                previousCompanySelection = vm.passengersData.frequentFlyer.iataCompanyCode;
            }
        }

        /**
         * Check if exist apis and required emergency data
         */
        function checkUsTracingAPIS() {
            const isInfant =
                angular.isObject(vm.passengersData.basicInfo) &&
                angular.isString(vm.passengersData.basicInfo.type) &&
                vm.passengersData.basicInfo.type === CheckinAppConstants.PASSENGER_TYPE.INFANT;
            const isRequiredEmergencyData =
                !isInfant && !vm.passengersData?.contactData?.emergencyInfo?.isOptional && vm.passengersData?.contactData?.emergencyInfo?.isPrivacyStatement;

            vm.ckeckApisUsTracing = FlightsPassengersUtils.initModelApisUsTracing();
            vm.ckeckApisUsTracing = FlightsPassengersUtils.checkExistAPIsUsTracing(vm.ckeckApisUsTracing, isRequiredEmergencyData);
        }

        /**
         * Check if required fields includes home address
         */
        function includesHomeAddress() {
            return vm.passengersData?.requiredFields?.includes("HOME_ADDRESS");
        }

        /**
         * Check if passenger is unique
         */
        function isUnique() {
            return vm.totalPas === 1;
        }
    }
})();
